/* @flow */
import * as React from "react";
import styled, { css } from "styled-components";
import Gettext from "../common/Gettext";
import { fontSize } from "../common/styled-mixins";

const deployTarget = process.env.REACT_APP_DEPLOY_TARGET;

const Button = styled.button`
  position: relative;
  height: 58px;
  margin: 0 auto;
  text-align: center;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;

  @media (min-width: 960px) {
    min-width: 132px;
  }

  ${props =>
    props.up &&
    css`
      margin-bottom: 10px;
      background-color: ${props => props.theme.upper};
      background: linear-gradient(
        0deg,
        ${props => props.theme.upper} 0%,
        ${props => props.theme.upperAccent} 100%
      );
      border-bottom: 2px solid ${props => props.theme.upperBorder};
      box-shadow: inset 0px -1px 0px 0px ${props => props.theme.upperBoxShadow};
      
      :hover,
      :active {
        background-color: ${props => props.theme.upperAccent};
        background: linear-gradient(
          0deg,
          ${props => props.theme.upperAccent} 0%,
          ${props => props.theme.upper} 100%
        );
        ${() =>
          deployTarget === "siamoption" &&
          css`
            box-shadow: 0 0 10px 4px rgba(96, 162, 29, 0.37);
          `};
      }

      :active {
        transform: translateY(1px);
      }

      @media (max-width: 959px) {
        :focus,
        :active {
          background-color: ${props => props.theme.upper};
          background: linear-gradient(
            0deg,
            ${props => props.theme.upper} 0%,
            ${props => props.theme.upperAccent} 100%
          );
          box-shadow: inset 0px -1px 0px 0px ${props => props.theme.upperBoxShadow};
          transform: translateY(0);
        }
      }

      @media (hover: none), (hover: on-demand) {
        :hover {
          background-color: ${props => props.theme.upper};
          background: linear-gradient(
            0deg,
            ${props => props.theme.upper} 0%,
            ${props => props.theme.upperAccent} 100%
          );
          box-shadow: inset 0px -1px 0px 0px ${props => props.theme.upperBoxShadow};
        }
      }
    `} ${props =>
    props.down &&
    css`
      box-shadow: inset 0px -1px 0px 0px ${props => props.theme.lowerBoxShadow};
      background-color: ${props => props.theme.lower};
      background-image: linear-gradient(
        0deg,
        ${props => props.theme.lower} 0%,
        ${props => props.theme.lowerAccent} 100%
      );
      border-bottom: 2px solid ${props => props.theme.lowerBorder};

      :hover,
      :active {
        background-color: ${props => props.theme.lowerAccent};
        background-image: linear-gradient(
          0deg,
          ${props => props.theme.lowerAccent} 0%,
          ${props => props.theme.lower} 100%
        );

        ${() =>
          deployTarget === "siamoption" &&
          css`
            box-shadow: 0 0 10px 4px rgba(214, 88, 88, 0.37);
          `};
      }

      :active {
        transform: translateY(1px);
      }

      @media (max-width: 959px) {
        :focus,
        :active {
          box-shadow: inset 0px -1px 0px 0px ${props => props.theme.lowerBoxShadow};
          background-color: ${props => props.theme.lower};
          background-image: linear-gradient(
            0deg,
            ${props => props.theme.lower} 0%,
            ${props => props.theme.lowerAccent} 100%
          );
          transform: translateY(0);
        }
      }

      @media (hover: none), (hover: on-demand) {
        :hover {
          box-shadow: inset 0px -1px 0px 0px ${props => props.theme.lowerBoxShadow};
          background-color: ${props => props.theme.lower};
          background-image: linear-gradient(
            0deg,
            ${props => props.theme.lower} 0%,
            ${props => props.theme.lowerAccent} 100%
          );
        }
      }
    `} @media(max-width: 959px) {
    width: 100%;
    height: 37px;
    margin: 0;
    border-radius: 4px;
    flex: 1 1 auto;
  }
`;

const Content = styled.span`
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
`;

const Text = styled.span`
  font-weight: 700;
  font-size: ${fontSize(16)};
  text-align: center;
  text-transform: uppercase;
  text-shadow: -1px -1px rgba(0, 0, 0, 0.22);
  color: #fff;

  @media (max-width: 959px) {
    font-size: ${fontSize(14)};
  }
`;

const Svg = styled.svg`
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 14px;
  margin-right: 7px;

  @media (max-width: 479px) {
    left: 11px;
  }
`;

type Props = {
  d: string
};

function Icon({ d }: Props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width="14px"
      height="14px"
      viewBox="0 0 16 16"
      fill="rgba(255, 255, 255, .55)"
    >
      <path d={d} />
    </Svg>
  );
}

export function CastUp(props: {}) {
  return (
    <Button up {...props}>
      <Content>
        <Icon d="M15.992,13.993 L15.992,0.001 L1.999,0.001 L1.999,3.998 L9.426,3.998 L0.618,12.807 L3.186,15.376 L11.995,6.567 L11.995,13.993 L15.992,13.993 Z" />
        <Text>
          <Gettext>Upper</Gettext>
        </Text>
      </Content>
    </Button>
  );
}

export function CastDown(props: {}) {
  return (
    <Button down {...props}>
      <Content>
        <Icon d="M15.992,1.990 L15.992,15.982 L1.999,15.982 L1.999,11.985 L9.426,11.985 L0.618,3.176 L3.186,0.607 L11.995,9.416 L11.995,1.990 L15.992,1.990 Z" />
        <Text>
          <Gettext>lower</Gettext>
        </Text>
      </Content>
    </Button>
  );
}



// WEBPACK FOOTER //
// ./src/components/TradeControls/Buttons.js